var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-insights" },
    [
      _c(
        "carousel",
        {
          attrs: { "per-page": 5, navigationEnabled: true, "mouse-drag": false }
        },
        [
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Touchpoints:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "font-size": "18px",
                        "margin-top": "20px",
                        "margin-bottom": "0px"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.touchPointTotalGeo +
                            _vm.touchPointStatsNonGeo +
                            _vm.totalDealDropTouchPoints +
                            _vm.touchPointStatsGeoNotAprove +
                            _vm.acceptedCountTouchPoints
                        )
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Impressions:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "font-size": "18px",
                        "margin-top": "20px",
                        "margin-bottom": "0px"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.impression
                            ? Number(_vm.impression).toLocaleString()
                            : "0"
                        )
                      )
                    ]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Deal Drops:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "font-size": "18px",
                        "margin-top": "20px",
                        "margin-bottom": "0px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.totalDealDropTouchPoints))]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Survey Responses:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "font-size": "18px",
                        "margin-top": "20px",
                        "margin-bottom": "0px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.totalResponses))]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Photos:")
                  ]),
                  _c(
                    "h2",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "font-size": "18px",
                        "margin-top": "20px",
                        "margin-bottom": "0px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.totalPhotos))]
                  )
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h3", { staticStyle: { "text-align": "left" } }, [
                    _vm._v("Activities with Notes:")
                  ])
                ]),
                _c("div", { staticClass: "col-md-6" }, [
                  _c(
                    "h2",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "font-size": "18px",
                        "margin-top": "20px",
                        "margin-bottom": "0px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.activitiesWithNotesNumber))]
                  )
                ])
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }